




















import { Component, Prop, Vue } from "vue-property-decorator";
import { gsap } from "gsap";
import { deviceType, isBrowser } from "mobile-device-detect";

@Component
export default class PreloadAppScreen extends Vue {
  @Prop({ default: false }) loading!: boolean;

  mounted(): void {
    console.log('Browser: ' + isBrowser);
    console.log('Device: ' + deviceType);
  }

  private onLeave(el: HTMLDivElement, done: Function): void {
    gsap.to(el, {
      y: '-100%',
      opacity: 0,
      duration: 1,
      ease: 'power3.out',
      onComplete: () => {
        console.log('Loading Finish');
        done();
      }
    });
  }
}
